$(document).ready(function() {
  // Close button
  if ($(".announcement-bar__close-button").length > 0) {
    let close_btns = $(".announcement-bar__close-button");
    
    close_btns.each((index, close_btn) => {
      let parent_section = $(close_btn).closest(".section-announcement");
      
      $(close_btn).on("click", () => {
        parent_section.hide();
        document.body.classList.add("announcement-hide");
      });
    });
  }

  // Slider
  if ($(".announcement-slider").length > 0) {
    const slider = $(".announcement-slider");
    const items = slider.find(".announcement-slider__item");
    let currentIndex = 0;

    function showSlide(index) {
      items.removeClass("active");
      items.eq(index).addClass("active");
    }

    slider.find(".announcement-slider__prev").on("click", function() {
      currentIndex = (currentIndex - 1 + items.length) % items.length;
      showSlide(currentIndex);
    });

    slider.find(".announcement-slider__next").on("click", function() {
      currentIndex = (currentIndex + 1) % items.length;
      showSlide(currentIndex);
    });

    // Otomatik geçiş (opsiyonel - 5 saniyede bir)
    setInterval(function() {
      currentIndex = (currentIndex + 1) % items.length;
      showSlide(currentIndex);
    }, 5000);
  }
});